import React from "react";
import { AuthenticationLayout } from "../components/Common/AuthLayout/AuthenticationLayout";
import { SignUpContent } from "../components/Authentication/SignUpContent";
import { SignInContent } from "../components/Authentication/SignInContent";
import { LockScreenContent } from "../components/Authentication/LockScreenContent";
import { LogOutContent } from "../components/Authentication/LogOutContent";
import { PasswordChangeContent } from "../components/Authentication/PasswordChangeContent";
import { PasswordResetContent } from "../components/Authentication/PasswordResetContent";
import { SuccessMsgContent } from "../components/Authentication/SuccessMsgContent";
import { ErrorPageContent } from "../components/Authentication/ErrorPageContent";
import { ErrorPageContentOne } from "../components/Authentication/ErrorPageContentOne";
import { TwoStepAuthContent } from "../components/Authentication/TwoStepAuthContent";
import { OfflinePageContent } from "../components/Authentication/OfflinePageContent";
import RootEntry from "./RootEntry";
import PublicRoute from "./PublicRoute";
import { ProfilePage } from "../pages/profilePage";
import { ChangePassword } from "../pages/ChangePassword";
import { DashboardPage } from "../pages/dashboardPage";
import { Navigate, useLocation } from "react-router-dom";
import { BlogsAdd } from "../pages/BlogsAdd";
import { BlogsManage } from "../pages/BlogsManage";
import { PageGroup } from "../pages/PageGroup";
import { PageMaster } from "../pages/PageMaster";
import { CreateRoles } from "../pages/CreateRoles";
import { ManageAccessPage } from "../pages/ManageAccess";
import { NewUser } from "../pages/NewUser";
import { NewUserView } from "../pages/NewUserView";
import { NewUserUpdate } from "../pages/NewUserUpdate";
import { UserDashboardPage } from "../pages/UserDashboardPage";
import { BrandAdd } from "../pages/MasterSettings/Brand/BrandAdd";
import { BrandManage } from "../pages/MasterSettings/Brand/BrandManage";
import { CategoryAdd } from "../pages/MasterSettings/Category/CategoryAdd";
import { CategoryManage } from "../pages/MasterSettings/Category/CategoryManage";
import { ContactManage } from "../pages/Contact/ContactManage";
import { SubCategoryAdd } from "../pages/MasterSettings/SubCategory/SubCategoryAdd";
import { SubCategoryManage } from "../pages/MasterSettings/SubCategory/SubCategoryManage";
import { CareerApplicationManage } from "../pages/Contact/CareerApplicationManage";
import { CareerManage } from "../pages/Career/CareerManage";
import { CareerAdd } from "../pages/Career/CareerAdd";
const ResetPasswordRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/auth/reset-password${search}`} replace />;
};

const RootTokenRedirect = () => <Navigate to="/dashboard" replace />;

const routes = [
  {
    path: "/",
    element: <RootEntry />,
    children: [
      { index: true, element: <RootTokenRedirect /> },
      { path: "page-group", element: <PageGroup /> },
      { path: "page-master", element: <PageMaster /> },
      { path: "create-role", element: <CreateRoles /> },
      {
        path: "Manage-role-access/:roleId/:roleName",
        element: <ManageAccessPage />,
      },

      { path: "user", element: <NewUserView /> },

      //routing for user management
      { path: "user", element: <NewUserView /> },
      {
        path: "user",
        children: [
          { path: "add", element: <NewUser /> },
          { path: "update/:id", element: <NewUserUpdate /> },
        ],
      },
      //--------------------------

      { path: "dashboard", element: <DashboardPage /> },
      { path: "user-dashboard", element: <UserDashboardPage /> },
      { path: "my-profile", element: <ProfilePage /> },
      { path: "change-password", element: <ChangePassword /> },
      //routing for blog management
      { path: "blogs", element: <BlogsManage /> },
      {
        path: "blogs",
        children: [
          { path: "add", element: <BlogsAdd /> },
          { path: "update/:id", element: <BlogsAdd /> },
        ],
      },
      { path: "brand", element: <BrandManage /> },
      {
        path: "brand",
        children: [
          { path: "add", element: <BrandAdd /> },
          { path: "update/:id", element: <BrandAdd /> },
        ],
      },
      { path: "category", element: <CategoryManage /> },
      {
        path: "category",
        children: [
          { path: "add", element: <CategoryAdd /> },
          { path: "update/:id", element: <CategoryAdd /> },
        ],
      },
      { path: "subcategory", element: <SubCategoryManage /> },
      {
        path: "subcategory",
        children: [
          { path: "add", element: <SubCategoryAdd /> },
          { path: "update/:id", element: <SubCategoryAdd /> },
        ],
      },
      { path: "contact-form", element: <ContactManage /> },
      { path: "contact", element: <ContactManage /> },
      { path: "career-application", element: <CareerApplicationManage /> },
      { path: "career", element: <CareerManage /> },
      {
        path: "career",
        children: [
          { path: "add", element: <CareerAdd /> },
          { path: "update/:id", element: <CareerAdd /> },
        ],
      },
      //------------------
    ],
  },
  {
    path: "/auth",
    element: (
      <PublicRoute>
        <AuthenticationLayout />
      </PublicRoute>
    ),
    children: [
      { path: "signup", element: <SignUpContent /> },
      { path: "signin", element: <SignInContent /> },
      { path: "lock-screen", element: <LockScreenContent /> },
      { path: "logout", element: <LogOutContent /> },
      { path: "password-change", element: <PasswordChangeContent /> },
      { path: "reset-password", element: <PasswordChangeContent /> },
      { path: "password-reset", element: <PasswordResetContent /> },
      { path: "success-message", element: <SuccessMsgContent /> },
      { path: "verification", element: <TwoStepAuthContent /> },
    ],
  },

  {
    path: "/forgot-password",
    element: <Navigate to="/auth/password-reset" replace />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordRedirect />,
  },
  {
    path: "/500-error-page",
    element: <ErrorPageContentOne />,
  },
  { path: "404-error-page", element: <ErrorPageContent /> },
  {
    path: "/offline",
    element: <OfflinePageContent />,
  },
];

export default routes;
